import { getTitleIndexStyle } from '../Title/titleUtils';

// Interligne d'une ligne de sommaire. Les lignes n'en posent pas (défaut du
// navigateur, ~1.2 selon la police) : la valeur est reprise ici pour traduire
// « sauter une ligne » en marge, faute de pouvoir mesurer le rendu.
const SUMMARY_LINE_HEIGHT = 1.2;

/**
 * Marge basse ajoutée par l'option « Sauter une ligne après ce titre », en px.
 *
 * Une marge plutôt qu'une ligne vide : le découpage du sommaire entre pages
 * parcourt les enfants de `.summary-wrapper` par index et les met en regard des
 * titres (cf. pdfGen), un élément intercalé fausserait la coupe.
 */
export const summarySkipLineMargin = (levelConfig) =>
  (levelConfig?.skipLineAfter
    ? Math.round((Number(levelConfig.fontSize) || 0) * SUMMARY_LINE_HEIGHT)
    : 0);

// Épaisseur du trait de liaison. Les points sont plus épais que le trait
// plein : à 1px, un pointillé ne se voit presque plus.
const LEADER_BORDER_WIDTHS = { dotted: 2, solid: 1 };

/**
 * CSS de la liaison (pointillés ou trait) entre un titre et son n° de page,
 * `null` sans liaison. Elle suit le n° de page : sans lui, elle ne relierait
 * rien.
 *
 * Posée sur le bas de la dernière ligne du titre, à hauteur de la ligne de
 * base, elle comble l'écart jusqu'au numéro.
 */
export const summaryLeaderStyle = (levelConfig, color) => {
  const width = LEADER_BORDER_WIDTHS[levelConfig?.pageLeader];
  if (!width || levelConfig.showPageNumber === false) return null;

  return {
    flex: '1 1 0',
    minWidth: 12,
    alignSelf: 'flex-end',
    fontSize: levelConfig.fontSize,
    margin: '0 0.4em 0.3em',
    borderBottom: `${width}px ${levelConfig.pageLeader} ${color}`,
  };
};

// Ce que le sommaire reprend du style de numéro des titres : l'aspect, pas les
// métriques. La taille et la police restent celles du sommaire — un numéro de
// titre tracé à 60px écraserait la ligne, et une autre police casserait
// l'alignement de la colonne des numéros (cf. SummaryTitleItem).
const MIRRORED_PROPERTIES = ['color', 'WebkitTextStroke', 'fontWeight'];

/**
 * CSS du numéro d'une ligne de sommaire.
 *
 * Vide tant que l'option est fermée : le numéro garde le style de sa ligne.
 * Ouverte, il reprend celui du niveau dans le document — la couleur du titre
 * si le numéro n'a pas la sienne, cas courant d'une numérotation qui suit
 * simplement la couleur de ses titres.
 */
export const summaryIndexStyle = ({ titleConfig, fromTitles }) => {
  if (!fromTitles) return {};

  const titleIndexStyle = getTitleIndexStyle(titleConfig);
  const style = {};
  const fallbackColor = titleConfig?.color?.style;
  if (fallbackColor) style.color = fallbackColor;

  MIRRORED_PROPERTIES.forEach((property) => {
    if (titleIndexStyle[property] !== undefined) style[property] = titleIndexStyle[property];
  });

  return style;
};
